// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"138bec21","142":"b21a1db3","150":"a6fcbb8c","185":"44a081d6","210":"6850a241","314":"e13099f8","389":"37da18f3","528":"5d2a63b1","571":"ad0c43f0","912":"37da18f3","954":"bcf58084"}[chunkId] + ".chunk.css";
};